<template>
  <div class="component-panel">
    <h3>Valuation Models</h3>
    <p>Users can input data to estimate fair value using DCF or comparables.</p>
  </div>
</template>
<script>
export default { name: 'ValuationModels' };
</script>
<style scoped>
.component-panel h3 { margin: 0 0 1rem 0; font-size: 1.2rem; font-weight: 700; }
.component-panel p { color: #64748b; }
</style> 